import { render, staticRenderFns } from "./post-feed.vue?vue&type=template&id=ee45b9ee&"
import script from "./post-feed.vue?vue&type=script&lang=js&"
export * from "./post-feed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports